import React, { useMemo } from 'react';
import { useSubscriberDomainParams } from 'global/hooks/useSubscriberDomainParams';
import IMQSubscriberDependentsPageStore, {
  IMQSubscriberDependentsPageStoreContext,
} from 'store/pages/subscriber/imq/imq-subscriber-dependents/pageStore';
import PageContent from 'components/subscriber/imq/imq-subscriber-dependents';

const IMQSubscriberDependentsPage: React.FC = () => {
  const { groupId, subscriberId, entityId } = useSubscriberDomainParams();

  const pageStore = useMemo(
    () => new IMQSubscriberDependentsPageStore({ groupId, subscriberId, entityId }),
    [groupId, subscriberId, entityId],
  );

  return (
    <IMQSubscriberDependentsPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </IMQSubscriberDependentsPageStoreContext.Provider>
  );
};

export default IMQSubscriberDependentsPage;
